import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import {
  ReconFlagsDetailDrawer,
  ReconFlagsFiltersCard,
  ReconFlagsGridCard,
  ReconFlagsSpotlightSummary,
  useReconFlagsPage,
} from '@ovComponents/4-module/reconFlags';
import { useThemeTokens } from '@providers/themeTokenProvider';

const ReconFlagsPage = () => {
  const { sys } = useThemeTokens();
  const { t, spotlightProps, filtersProps, gridProps, drawerProps } =
    useReconFlagsPage(sys);

  return (
    <Box display='flex' flexDirection='column' gap={2.5}>
      <Typography variant='titleMedium'>
        {t('reconFlags.summaryTitle')}
      </Typography>

      <ReconFlagsSpotlightSummary {...spotlightProps} />

      <ReconFlagsFiltersCard {...filtersProps} />

      <ReconFlagsGridCard {...gridProps} />

      <ReconFlagsDetailDrawer {...drawerProps} />
    </Box>
  );
};

export default ReconFlagsPage;
